import { createSlice } from "@reduxjs/toolkit";

interface UIState {
	sidebarOpened: boolean;
	theme: "light" | "dark";
	loading: boolean;
}

const initialState: UIState = {
	sidebarOpened: true,
	theme: "light",
	loading: false,
};

const uiSlice = createSlice({
	name: "ui",
	initialState,
	reducers: {
		toggleSidebar: (state) => {
			state.sidebarOpened = !state.sidebarOpened;
		},
		setSidebarOpened: (state, action) => {
			state.sidebarOpened = action.payload;
		},
		toggleTheme: (state) => {
			state.theme = state.theme === "light" ? "dark" : "light";
		},
		setLoading: (state, action) => {
			state.loading = action.payload;
		},
	},
});

export const { toggleSidebar, setSidebarOpened, toggleTheme, setLoading } =
	uiSlice.actions;
export default uiSlice.reducer;
